//@flow
import React, { useEffect, useRef } from 'react';
import { RichText } from 'prismic-reactjs';
import useScrollPosition from '../../helpers/useScrollPosition';
import { PrismicSearchDoc } from '../../types/prismic';
import styles from './search-header.module.sass';

type Props = {
  copy: PrismicSearchDoc;
  onMinimize: (boolean) => void;
};

const SearchHeader = ({ copy, onMinimize }: Props) => {
  const scrollPosition = useScrollPosition();
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    onMinimize(scrollPosition > 100);
  }, [scrollPosition]);

  if (!copy) return null;
  const { header, description } = copy.data;

  return (
    <div ref={titleRef} className={styles.title}>
      <div className={styles.inner}>
        <h3>{header}</h3>
      </div>
      <RichText render={description} />
    </div>
  );
};

export default SearchHeader;
